// extracted by mini-css-extract-plugin
export default {"legal":"legal-module--legal--PWH+P","copyright":"legal-module--copyright--zdy+q","link":"legal-module--link--ZrHBK"};